import FaqDesktop from "@/components/FaqDesktop"
import { Logo } from "@/components/Logo"
import PrivacyComponent from "./privacy_component"
import { NavigationButtons } from "@/components/NavigationButtons"
import { routes } from "@/navigation"
import { ConfigSlim, ConfigSlimStep } from "@/types/configuration"
import { ReactElement, useEffect, useState } from "react"
import { ConsentItem } from "@/types/typesInterfaces"
import { performConsent, updateExecution } from "@/utils/client/client_api"
import { signInAnonymously } from "firebase/auth"
import { getFirebaseClientAuth } from "@/lib/firebase-client-config"

interface Props {
    texts: any
    locale: string
    configInfo: ConfigSlim
    configStep: ConfigSlimStep
    goToAuthPath: () => void
    tenantMessageElement?: ReactElement
}

const WithoutAuthComponent = ({ locale, texts, configInfo, configStep, goToAuthPath, tenantMessageElement }: Props) => {

    const [consentStates, setConsentStates] = useState<ConsentItem[]>([]);
    const [consentsCatalogue, setConsentsCatalogue] = useState<any>();

    useEffect(() => {
        getConsents()
    }, [])

    const checkConsentUserChoiches = () => {
        if (consentStates.length == 0) {
            return false
        }
        return consentStates.every((consent) => {
            if (consent.flagMandatory) {
                return consent.accepted === true;
            }
            return true;
        });
    }

    const onNext = async (): Promise<boolean> => {
        updateExecution({
            executionConsents: consentStates
        });
        return true;
    }

    const handleConsentChange = (index) => {
        const temp = [...consentStates]
        temp[index].accepted = !temp[index].accepted;
        setConsentStates(temp);
    };

    const getConsents = async () => {
        try {
            const firebaseClientAuth = await getFirebaseClientAuth();
            if (!firebaseClientAuth) {
                throw new Error('firebaseClientAuth is null');
            }

            const anonymousUserCredentials = await signInAnonymously(firebaseClientAuth);

            if (anonymousUserCredentials.user) {
                const anonymousToken = await anonymousUserCredentials.user.getIdToken();

                const responseConsent = await performConsent(locale, anonymousToken);
                if (responseConsent.isOk) {
                    const fetchedConsents = responseConsent.response;
                    setConsentsCatalogue(fetchedConsents);
                    setConsentStates(
                        fetchedConsents.map((c) => ({
                            consentCode: c.consentCode,
                            category: c.category,
                            answerType: c.answerType,
                            flagAccMandatory: c.flagAccMandatory,
                            flagMandatory: c.flagMandatory,
                            accepted: false,
                            startValidityDate: c.startValidityDate,
                            title: c.consentContent[0].title

                        }))
                    );
                } else {
                    console.error(responseConsent);
                }
            }
        } catch (error) {
            console.error("Error during performConsent", error);
        }
    }

    const renderAuthPath = () => {
        if (!configInfo.hasLogin) {
            return null;
        }
        return <>
            <div className="mt-5">

            </div>

            <div className="my-5 underline hover:cursor-pointer" onClick={goToAuthPath} dangerouslySetInnerHTML={{ __html: texts.returnToLogin }}>
            </div>
        </>
    }

    return (
        <div className="h-full flex flex-col justify-center">

            <h1 className="mb-4 font-inter text-2xl font-semibold tracking-normal text-primaryBlue950">
                {texts.title1} {texts.title2} {texts.title3}
            </h1>
            <div className="mb-6">
                <Logo />
            </div>

            <div className="mb-3 text-md tracking-normal text-primaryBlue950">
                {texts.text1}
            </div>
            {/* <div className="mb-3 text-md tracking-normal text-primaryBlue950">
                {texts.text2}
            </div> */}

            <div className="mt-5 mb-5 flex flex-col gap-4 flex-none">
                <PrivacyComponent
                    texts={texts}
                    consentsCatalogue={consentsCatalogue}
                    consentStates={consentStates}
                    handleConsentChange={handleConsentChange} />
                <NavigationButtons
                    next={routes[configStep.nextOptions[0].name]}
                    text={texts.cCta}
                    stepIsValidated={checkConsentUserChoiches()}
                    completedQuestion={configStep.routeName}
                    onClick={onNext}
                />
            </div>
            {renderAuthPath()}
            <div className="flex justify-center items-center">
                <span className="text-primaryBlue700"><FaqDesktop texts={texts} /></span>
            </div>
        </div>
    );
}

export default WithoutAuthComponent;
